import React, { useMemo, useRef, useEffect } from 'react';

import { useSelector } from 'react-redux';

import { UnidataTable, Modal } from '~/components';
import { format, parseISO } from 'date-fns';
import DetalheCertificado from './components/DetalheCertificado';
import { recordFiltering } from '~/store/modules/vtCertificados/actions'

import { Visibility } from '@material-ui/icons';



export default function RelVtCertificados() {

    const vtcertificados = useSelector((state) => state.vtCertificados)

    const detalheCertificadoRef = useRef(null)



    const header = useMemo(
        () => [
            {
                id: 'avta_cod_avta',
                label: 'Número do VT',
                filter: {
                    type: 'text',
                },
            },
            {
                id: 'empe_desc',
                label: 'Empresa',
                filter: {
                    type: 'text',
                },
            },
            {
                id: 'avta_num_certificado',
                label: 'Número de Certificado',
                filter: {
                    type: 'text',
                },
            },
            {
                id: 'avta_dta_afericao',
                label: 'Data Aferição',
                formatted: (value) => format(parseISO(value), 'dd/MM/yyyy'),
                filter: {
                    type: 'date',
                },
            },
            {
                id: 'avta_dta_vencimento',
                label: 'Data Vencimento',
                formatted: (value) => format(parseISO(value), 'dd/MM/yyyy'),
                filter: {
                    type: 'date',
                },
            },


        ],
        []
    );
    const buttons = useMemo(() => {
        return [
            {
                title: 'Detalhe Atendimento',
                action: (value) => detalheCertificadoRef.current.handleOpenModal({
                    reference: detalheCertificadoRef,
                    data: value,
                }),
                icon: <Visibility />,
            }
        ];
    }, [detalheCertificadoRef]);

    const modalButtons = useMemo(() => [{
        label: 'Fechar',
        color: 'secondary',
        callback: () => detalheCertificadoRef.current.handleCloseModal()

    }], [detalheCertificadoRef])

    return (
        <>
            <UnidataTable
                fixed
                title="Relação De Vagões"
                create={false}
                update={false}
                delete={false}
                actions={buttons}
                header={header}
                redux={vtcertificados}
                read={recordFiltering}
                detach="avta_num_certificado"
                keys="avta_num_certificado"
            />

            <Modal
                disableBackdropClick
                disableEscapeKeyDown
                ref={detalheCertificadoRef}
                title="Relação de Vagões"
                maxWidth="lg"
                fullScreen={window.innerWidth <= 425}
                component={DetalheCertificado}
                actions={modalButtons}
            />

        </>
    )
}